import { render, staticRenderFns } from "./HeartysanCategoryCreation.vue?vue&type=template&id=fdfee0d6&scoped=true"
import script from "./HeartysanCategoryCreation.vue?vue&type=script&lang=js"
export * from "./HeartysanCategoryCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfee0d6",
  null
  
)

export default component.exports